import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { AppType } from '@insurgrid/common';
import { SuccessType } from './types';
import { Feature } from './services/feature.service';

export const UserContext = createContext<{
  setHasAcceptedTerms: (value: boolean) => void;
  setSuccessType: (value: SuccessType) => void;
  hasAcceptedTerms: boolean;
  successType?: SuccessType;
  showExtractedData: boolean;
  setShowExtractedData: (value: boolean) => void;
}>({
  setHasAcceptedTerms: (_v: boolean) => {},
  setSuccessType: (_v: SuccessType) => {},
  hasAcceptedTerms: false,
  showExtractedData: false,
  setShowExtractedData: (_v: boolean) => {
    // NO-OP
  },
});

export const FeatureContext = createContext<Record<Feature, boolean> | null>(
  null,
);
/**
 * returns a string array of all features that are online
 * if a feature is enabled it'll be included in this array
 * */
export const useFeatureContext = () => useContext(FeatureContext);

export const AppModalContext = createContext<{
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  showExit: boolean;
  setShowExit: (isOpen: boolean) => void;
}>({
  isOpen: false,
  setIsOpen: () => null,
  showExit: false,
  setShowExit: () => null,
});

export const useAppModalContext = () => useContext(AppModalContext);

export const AnimationFinishedContext = createContext<{
  animationFinished: boolean;
  setAnimationFinished: (animationFinished: boolean) => void;
}>({ animationFinished: false, setAnimationFinished: () => {} });

export const useAnimationFinishedContext = () =>
  useContext(AnimationFinishedContext);

export const DemoContext = createContext<{
  stepIndex: number;
  setStepIndex: Dispatch<SetStateAction<number>>;
  stepCompleted: boolean;
  setStepCompleted: Dispatch<SetStateAction<boolean>>;
}>({
  stepIndex: 0,
  setStepIndex: () => null,
  stepCompleted: false,
  setStepCompleted: () => null,
});

export const useDemoContext = () => useContext(DemoContext);

export const AppTypeContext = createContext<AppType>(AppType.PolicyConnect);
export const useAppTypeContext = () => useContext(AppTypeContext);
